import React from "react";
import PropTypes from "prop-types";
import "./styles.css";

export default function InfoDialog({
  open,
  title = "Information",
  message,
  onClose,
  onConfirm,
  onCancel,
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  okLabel = "OK"
}) {
  if (!open) return null;

  const isConfirm = onConfirm && onCancel;

  return (
    <div className="info-dialog-backdrop">
      <div className="info-dialog">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="info-dialog-actions">
          {isConfirm ? (
            <>
              <button onClick={onCancel}>{cancelLabel}</button>
              <button className="confirm" onClick={onConfirm}>
                {confirmLabel}
              </button>
            </>
          ) : (
            <button onClick={onClose}>{okLabel}</button>
          )}
        </div>
      </div>
    </div>
  );
}

InfoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  okLabel: PropTypes.string
};
